<template>
  <div id="reservationlist" class="container">
    <div class="row">
      <div class="col-12 mask-settings" v-if="!reservation.masks">
        <div class="mask-option-group">
          <h3 v-if="!submitted">You don't have any items in your list!</h3>
          <h3 v-if="submitted">Thank you for your request.</h3>
          <h4 v-if="submitted">Look out for an email from <b>info@oro.gg</b></h4>
        </div>
      </div>
      <div class="col-12 mask-settings" v-else>
        <div class="mask-option-group">
          <h4>{{reservation.masks.length}} masks</h4>
        </div>
      </div>
    </div>
    <div
      class="row"
      v-for="(mask, i) in reservation.masks"
      v-bind:key="i" :id="'mask' + i"
      >
      <div class="col-12 mask-card"
        v-bind:style="{ 'background': 'url(' + mask.thumbURL + ') 0 0/cover'}">
        <div class="row">
          <div class="col-12 title-container" @click="biggerImage(mask)">
            <div class="title">{{mask.name}}</div>
          </div>
        </div>
        <div class="row details-container">
          <!-- <div class="col-1-sm">
            <div class="col-12-sm mask-option index">{{i+1}}</div>
          </div> -->
          <div class="col-6-sm">
            <div class="col-6-sm group-type" @click="setType(i, 'elastic')">
              <div class="mask-option button" v-bind:class="{selected: mask.type=='elastic'}">
                elastic
              </div>
            </div>
            <div class="col-6-sm group-type" @click="setType(i, 'string')">
              <div class="mask-option button" v-bind:class="{selected: mask.type=='string'}">
                string
              </div>
            </div>
          </div>
          <div class="col-4-sm">
            <div class="col-4-sm group-size" @click="setSize(i, 's')">
              <div class="mask-option button" v-bind:class="{selected: mask.size=='s'}">
                s
              </div>
            </div>
            <div class="col-4-sm group-size" @click="setSize(i, 'm')">
              <div class="mask-option button" v-bind:class="{selected: mask.size=='m'}">
                m
              </div>
            </div>
            <div class="col-4-sm group-size" @click="setSize(i, 'l')">
              <div class="mask-option button" v-bind:class="{selected: mask.size=='l'}">
                l
              </div>
            </div>
          </div>
          <div class="col-2-sm">
            <div class="col-12-sm group-one" @click="removeFromList(i, mask)">
              <div class="mask-option delete button"><font-awesome-icon :icon="['fa', 'trash-alt']" /></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="reserve">
      <button class="button" v-if="reservation.masks && reservation.masks.length > 0" @click="submitModal">Submit Reservation</button>
    </div>
  </div>
</template>

<script>
import {reservationsRef, masksRef, fire} from '../firebase/firebaseConfig.js'
export default {
  name: 'ReservationList',
  props: {},
  mounted() {},
  data: function (){
    return {}
  },
  methods: {
    submitModal() {
      this.$store.commit('setModal', {
        name: 'Reservation Info',
        type: 'submit',
        masks: this.reservation
      })
    },
    setType(i, type) {
      // let vm = this
      let updatedMasks = [...this.reservation.masks]
      let updated = {...updatedMasks[i], type: type}
      delete updated.id
      updatedMasks[i] = updated
      let path = {...this.reservation}
      path.masks = updatedMasks
      path.updated = new Date()
      reservationsRef.doc(this.reservation.id).update(path).then(function() {
      }).catch(function(error) {
        console.log('error', error)
      })
    },
    setSize(i, size) {
      // let vm = this
      let updatedMasks = [...this.reservation.masks]
      let updated = {...updatedMasks[i], size: size}
      delete updated.id
      updatedMasks[i] = updated
      let path = {...this.reservation}
      path.masks = updatedMasks
      path.updated = new Date()
      reservationsRef.doc(this.reservation.id).update(path).then(function() {
      }).catch(function(error) {
        console.log('error', error)
      })
    },
    removeFromList(i, mask) {
      // let vm = this
      // let updated = {...this.reservation.masks[i], size: size}
      // delete updated.idcapital: firebase.firestore.FieldValue.delete()
      let updatedMasks = [...this.reservation.masks]
      updatedMasks.splice(i, 1)
      let path = {
        masks: updatedMasks,
        updated: new Date()
      }
      // path['masks.'+i] = fire.firestore.FieldValue.delete()
      reservationsRef.doc(this.reservation.id).update(path).then(function() {
        // adjust also the reservations
          let update = {
            pending: fire.firestore.FieldValue.increment(-1)
          }
          masksRef.doc(mask.uuid).update(update).then(function() {
          }).catch(function(error) {
            console.log('error', error)
          })
      }).catch(function(error) {
        console.log('error', error)
      })
    },
    addToList() {
      if (this.data.available > this.desiredMasks.length) {
        this.desiredMasks.push({
          type: null,
          size: null
        })
        // let element = "mask" + (this.desiredMasks.length -1).toString()
        setTimeout(function(){
          let newRow = document.getElementById("add")
          newRow.scrollIntoView({ behavior: 'smooth', block: 'end' })
        }, 10)

      }
    },
    biggerImage(mask) {
      this.$store.commit('setImageModal', {...mask})
    }
  },
  computed: {
    reservation () {
      return this.$store.getters.getReservationList
    },
    submitted () {
      return this.$store.getters.getReservationSent
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h3, h4 {
   padding: 0;
   margin: 0;
   font-size: 18px;
}
h4 {
  font-weight: normal;
  font-size: 18px;
}
.title-container {
  background: rgba(255,255,255,.7);
  margin: 0;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  width: 100%;
  .title {
    color: black;
    text-align: left;
    font-weight: bold;
    padding: 5px 10px;
  }
}

.index {
  text-shadow: 2px 2px 2px black;
}
.modal-scrollable {
  overflow-y: auto;
  height: 80%;
}
// .mask-settings {
//   padding: 2px 0;
//   margin: 2px auto;
//   display: inlne-block;
// }
// .mask-option-group {
//   // border: 1px solid white;
//   display: inline-block;
//   text-align: center;
//   padding: 5px;
// }
.group-one {
  .mask-option {
    border-radius: 4px;

  }
}
.group-type {
  &:first-child {
    margin-right: 0;
    .mask-option {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right: 1px solid white;
    }
  }
  &:last-child {
    margin-left: 0;
    .mask-option {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      border-left: 1px solid white;
    }
  }
}
.group-size {
  &:first-child {
    margin-right: 0;
    .mask-option {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right: 1px solid white;
    }
  }
  &:last-child {
    margin-left: 0;
    .mask-option {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      border-left: 1px solid white;
    }
  }
  &:not(:first-child) {
    &:not(:last-child) {
      margin-left: 0;
      margin-right: 0;
    }
  }
}
.mask-option {
  color: black;
  // text-align: center;
  // display: inlne-block;
  background: none;
  border: 2px solid white;
  border-right: 1px solid white;
  border-left: 1px solid white;
  padding: 5px 0;
  background: rgba(255,255,255,.8);
}
.selected {
  background: $oroGold;
  border-color: $oroGold;
  font-weight: bold;
}
.mask-card {
  border-radius: 4px;
  border: 2px solid black;
  margin: 5px auto;
}
.delete {
  background: #8b0000;
  color: white;
  border-color: #8b0000;
}
// #add {
//   #add-button {
//     display: inline-block;
//     padding: 10px 20px;
//     margin: 10px;
//     background: #e9c46a;
//     color: black;
//     font-weight: bold;
//     border-radius: 5px;
//     border: 2px solid #e9c46a;
//   }
// }
// #modal-content {
//   background: rgba(0,0,0,.75);
//   height: 100%;
//   width: 100%;
// }
// #modal {
//   width: 90%;
//   position: fixed;
//   z-index: 100;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   margin: auto;
//   background: white;
//   height: 70%;
//   border: 2px solid black;
//   border-bottom: none;
//   border-radius: 5px 5px 0 0;
//   #modal-title {
//     font-weight: bold;
//     font-size: 24px;
//     padding: 5px 0;
//   }
// }
// #modal-footer {
//   position: absolute;
//   bottom: 0;
//   left: 0;
//   right: 0;
//   padding: 10px 20px;
//   background: rgba(155,0,0,.9);
//   color: white;
//   font-weight: bold;
//   height: 50px;
//   margin: 5px auto 0;
//   .modal-footer-button {
//     cursor: pointer;
//     display: inline-block;
//     margin: 0 5px;
//     border: 1px solid white;
//     padding: 5px 10px;
//   }
// }
#reserve {
  button {
    padding: 20px 40px;
    border: 2px solid black;
    border-radius: 4px;
    font-weight: bold;
    margin: 20px auto;
    background: #e9c46a;
    font-size: 18px;
  }
}

#reservationlist {
  min-height:400px;
}
</style>
